import * as Types from '@/types/schema';

import gql from 'graphql-tag';
export type JobContentFragment = { id: string, createdAt: string, jobScheduleId: string, status: Types.JobEntityStatusEnum, mediaUrls: Array<{ fileName?: string | null }>, meta?: { skillsImportMetadata?: { createdSkillsCount: number } | null, bulkUnAssignLearnerMetadata?: { unAssignableLearnersCount: number, totalLearnersCount: number } | null } | null, input?: { offlineEventAttendanceImportInput?: { eventId: string } | null, quizQuestionImportInput?: { quizId?: string | null } | null, bulkUnAssignContentPropsInput?: { entityId: string, userIds?: Array<string> | null, learnerGroupIds?: Array<string> | null } | null, forceCompleteContentInput?: { userIds: Array<string>, entityIds: Array<string> } | null, downloadJourneyPerformancesTemplateInput?: { journeyId: string, phaseId: string } | null, bulkImportJourneyPerformancesInput?: { journeyId: string, phaseId: string } | null } | null };


export type JobContentFragmentVariables = Types.Exact<{ [key: string]: never; }>;

export const JobContentFragmentDoc = /*#__PURE__*/ gql`
    fragment JobContent on JobType {
  id
  createdAt
  jobScheduleId
  status
  mediaUrls {
    fileName
  }
  meta {
    skillsImportMetadata {
      createdSkillsCount
    }
    bulkUnAssignLearnerMetadata {
      unAssignableLearnersCount
      totalLearnersCount
    }
  }
  input {
    offlineEventAttendanceImportInput {
      eventId
    }
    quizQuestionImportInput {
      quizId
    }
    bulkUnAssignContentPropsInput {
      entityId
      userIds
      learnerGroupIds
    }
    forceCompleteContentInput {
      userIds
      entityIds
    }
    downloadJourneyPerformancesTemplateInput {
      journeyId
      phaseId
    }
    bulkImportJourneyPerformancesInput {
      journeyId
      phaseId
    }
  }
}
    `;